import { Link } from '@mui/joy'

export const getAdminUserAssignedHeaders = () => {
  const headers = [
    { label: 'Imię', propName: 'firstName' },
    { label: 'Nazwisko', propName: 'lastName' },
    {
      label: 'E-mail',
      propName: 'email',
      type: 'computed',
      fn: (user) => (user.email ? <Link href={`mailto:${user.email}`}>{user.email}</Link> : '-'),
    },
  ]

  return headers
}
